import React from 'react';
//styles
import styles from 'src/asset/scss/style/market.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function Market(props) {
    const { data } = props;

    return (
        <Element tag={`div`}>
            <Element tag={`div`} className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL}${data.IMG_SRC}`} alt={data.SUBJECT} /></Element>
            <Element tag={`h1`}>{data.PARTNER_NAME}</Element>
            <Element tag={`p`}>{data.SUBJECT}</Element>
            <Element tag={`small`}><Element tag={`strong`}>{data.DISCOUNT}%</Element><Element tag={`span`}>{data.PRICE}원</Element></Element>
        </Element>
    );
}